"use client"

import type React from "react"

import { useCallback } from "react"

// Fonction pour générer des confettis
export function triggerConfetti() {
  // Dynamically import canvas-confetti to avoid SSR issues
  import("canvas-confetti").then((confetti) => {
    const count = 200
    const defaults = {
      origin: { y: 0.7 },
      zIndex: 1000,
    }

    function fire(particleRatio: number, opts: any) {
      confetti.default({
        ...defaults,
        ...opts,
        particleCount: Math.floor(count * particleRatio),
      })
    }

    // Lancer des confettis colorés dans différentes directions
    fire(0.25, {
      spread: 26,
      startVelocity: 55,
      colors: ["#FF4E00", "#FFA500", "#FFD700"],
    })

    fire(0.2, {
      spread: 60,
      colors: ["#FF4E00", "#FFA500", "#FFD700"],
    })

    fire(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8,
      colors: ["#FF4E00", "#FFA500", "#FFD700"],
    })

    fire(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2,
      colors: ["#FF4E00", "#FFA500", "#FFD700"],
    })

    fire(0.1, {
      spread: 120,
      startVelocity: 45,
      colors: ["#FF4E00", "#FFA500", "#FFD700"],
    })
  })
}

interface ConfettiButtonProps {
  onClick?: () => void
  children: React.ReactNode
  className?: string
}

export function ConfettiButton({ onClick, children, className }: ConfettiButtonProps) {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      triggerConfetti()
      if (onClick) onClick()
    },
    [onClick],
  )

  return (
    <button onClick={handleClick} className={className}>
      {children}
    </button>
  )
}
